import { useEffect } from "react";

/**
 * Warns before a reload or tab close while the open chat still holds a message
 * that has not been sent. Browsers ignore any custom string here and show their
 * own wording, so the only thing worth controlling is whether it appears.
 *
 * Switching chats is handled separately, by UnsentMessagesGuardProvider, which
 * can show real copy.
 */
export function useUnresolvedSendWarning(hasUnresolvedSends: boolean): void {
  useEffect(() => {
    if (!hasUnresolvedSends) {
      return;
    }

    const warnBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", warnBeforeUnload);
    return () => window.removeEventListener("beforeunload", warnBeforeUnload);
  }, [hasUnresolvedSends]);
}
